import { useMemo } from 'react';
import { allowedTypesToFilter } from 'components/common/Table/tableFunctions';
import type { UserAgendaTableDataSchemaType } from 'types';

interface UseFilterVisibilityProps {
  dataSchema: UserAgendaTableDataSchemaType;
}

export function useFilterVisibility({ dataSchema }: UseFilterVisibilityProps) {
  const canShowFilters = useMemo(() => {
    return Object.keys(dataSchema).some((key) => {
      const type = dataSchema[key].type;
      return allowedTypesToFilter.includes(type);
    });
  }, [dataSchema]);

  return { canShowFilters };
}
